// import React from "react";
// import { Button } from "react-bootstrap";

// // css
// import styles from "./Table.module.scss";
// import Loading from "../Common/Loading";

// // image

// const TableLayout = ({ column, data, loader }) => {
//   return (
//     <>
//       <div className={`${styles.scrollWrapper} table-responsive`}>
//         <table className={`${styles.table} table`}>
//           <thead>
//             <tr className="border">
//               {column &&
//                 column.length > 0 &&
//                 column.map((item, key) => (
//                   <>
//                     <th className="text-muted fw-bold">{item.head}</th>
//                   </>
//                 ))}
//             </tr>
//           </thead>
//           <tbody>
//             {!loader && data &&
//               data?.length > 0 &&
//               data.map((data, columnkey) => {
//                 return (
//                   <tr>
//                     {column &&
//                       column.length > 0 &&
//                       column.map((item, key) => {
//                         if (item.component) {
//                           return (
//                             <td className="border-bottom border-secondary">
//                               {item.component(data, columnkey, data)}
//                             </td>
//                           );
//                         }

//                         return (
//                           <td className="border-bottom border-secondary">
//                             {data[item?.accessor]}
//                           </td>
//                         );
//                       })}
//                   </tr>
//                 );
//               })}
//             {!!loader && (
//               <tr>
//                 <td colSpan={column.length} align="center">
//                   <Loading />
//                 </td>
//               </tr>
//             )}
//             {!loader && !!!data?.length && (
//               <tr>
//                 <td colSpan={column.length}>
//                   <p className="text-center">No Data Found!</p>
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </>
//   );
// };

// export default TableLayout;


import React, { useRef, useState } from "react";
import { Button } from "react-bootstrap";
import styles from "./Table.module.scss";
import Loading from "../Common/Loading";
import { useTranslation } from "react-i18next";

const TableLayout = ({ column, data, loader }) => {
  const {t} = useTranslation();
  const scrollRef = useRef(null);
  const [isDown, setIsDown] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e) => {
    setIsDown(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
  };

  const handleMouseLeave = () => setIsDown(false);
  const handleMouseUp = () => setIsDown(false);

  const handleMouseMove = (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 1; // speed multiplier
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <div
      ref={scrollRef}
      className={`${styles.scrollWrapper} table-responsive`}
      onMouseDown={handleMouseDown}
      onMouseLeave={handleMouseLeave}
      onMouseUp={handleMouseUp}
      onMouseMove={handleMouseMove}
    >
      <table className={`${styles.table} table`}>
        <thead>
          <tr className="border">
            {column?.map((item, key) => (
              <th key={key} className="text-muted fw-bold">{item.head}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {!loader && data?.length > 0 &&
            data.map((row, i) => (
              <tr key={i}>
                {column.map((item, key) => (
                  <td key={key} className="border-bottom border-secondary">
                    {item.component ? item.component(row, i, row) : row[item.accessor]}
                  </td>
                ))}
              </tr>
            ))}
          {!!loader && (
            <tr>
              <td colSpan={column.length} align="center">
                <Loading />
              </td>
            </tr>
          )}
          {!loader && !!!data?.length && (
            <tr>
              <td colSpan={column.length}>
                <p className="text-center">{t("common.noData")}!</p>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TableLayout;

